import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { renderSR } from '../../../utils/common';

const nav = {
  home: {
    title: 'home',
    key: 'home',
    path: '/home',
  },
  adminHome: {
    title: 'admin list',
    key: 'admin-list',
    path: '/admin/home',
  },
  configuration: {
    title: 'configuration',
    key: 'configuration',
    path: '/admin/configure-install',
  },
  configureInstall: {
    title: 'configure install',
    key: 'configure-install',
    path: '/admin/configure-install',
  },
  instanceFields: {
    title: 'instance fields',
    key: 'instance-fields',
    path: '/admin/instance-fields',
  },
  manageUsers: {
    title: 'manage users',
    key: 'manage-users',
    path: '/admin/manage-users',
  },
  documents: {
    title: 'help docs',
    key: 'documents',
    path: 'https://datarista.github.io/Documentation/#marketo_documentation', // '/admin/documents',
  },
};

export default class AdminSidebar extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    highlight: PropTypes.string.isRequired,
    installId: PropTypes.string,
  };

  static defaultProps = {
    data: null,
    installId: null,
  };

  setSidebarClass = () => {
    const { highlight } = this.props;
    let sidebarClass = 'sidebar-wrapper';
    if (highlight === nav.adminHome.key) {
      sidebarClass += ' admin-home-sidebar';
    } else if (highlight === nav.configureInstall.key || highlight === nav.instanceFields.key) {
      sidebarClass += ' admin-install-sidebar';
    }
    return sidebarClass;
  };

  renderAdminLinks = () => {
    const { highlight, installId, data } = this.props;
    let submenuActive = false;
    const isMarketo = data && data.platformCode === 'MARKETO';
    const isEloqua = data && data.platformCode === 'ELOQUA';
    if (highlight === nav.configureInstall.key || highlight === nav.instanceFields.key) {
      submenuActive = true;
    }
    return (
      <ul className="sidebar-nav admin-nav">
        <div>
          <li className={highlight === nav.home.key ? 'sidebar-item active' : 'sidebar-item'}>
            <Link className="nav-link" to={nav.home.path}>
              <span className={`menu-icon ${nav.home.key}`} />
              {nav.home.title}
              {highlight === nav.home.key ? this.renderCurrent() : null}
            </Link>
          </li>
          <li className={highlight === nav.adminHome.key ? 'sidebar-item active' : 'sidebar-item'}>
            <Link className="nav-link" to={nav.adminHome.path}>
              <span className={`menu-icon ${nav.adminHome.key}`} />
              {nav.adminHome.title}
              {highlight === nav.adminHome.key ? this.renderCurrent() : null}
            </Link>
          </li>
        </div>
        {highlight !== nav.adminHome.key ? (
          <div>
            {isMarketo ? (
              <li
                className={
                  highlight === nav.configuration.key || submenuActive
                    ? 'sidebar-item active'
                    : 'sidebar-item'
                }
              >
                <Link className="nav-link" to={`${nav.configuration.path}/${installId}`}>
                  <span className={`menu-icon ${nav.configureInstall.key}`} />
                  {nav.configuration.title}
                  {highlight === nav.configuration.key ? this.renderCurrent() : null}
                  <span className={`caret ${submenuActive ? 'hidden' : 'show'}`} />
                </Link>
                <ul className={`submenu ${submenuActive ? 'open' : 'collapse'}`}>
                  <li
                    className={
                      highlight === nav.configureInstall.key
                        ? 'sidebar-item active'
                        : 'sidebar-item'
                    }
                  >
                    <Link className="nav-link" to={`${nav.configureInstall.path}/${installId}`}>
                      {nav.configureInstall.title}
                      {highlight === nav.configureInstall.key ? this.renderCurrent() : null}
                    </Link>
                  </li>
                  <li
                    className={
                      highlight === nav.instanceFields.key ? 'sidebar-item active' : 'sidebar-item'
                    }
                  >
                    <Link className="nav-link" to={`${nav.instanceFields.path}/${installId}`}>
                      {nav.instanceFields.title}
                      {highlight === nav.instanceFields.key ? this.renderCurrent() : null}
                    </Link>
                  </li>
                </ul>
              </li>
            ) : null}
            {isEloqua ? (
              <li
                className={
                  highlight === nav.configureInstall.key ? 'sidebar-item active' : 'sidebar-item'
                }
              >
                <Link className="nav-link" to={`${nav.configureInstall.path}/${installId}`}>
                  <span className={`menu-icon ${nav.configureInstall.key}`} />
                  {nav.configuration.title}
                  {highlight === nav.configureInstall.key ? this.renderCurrent() : null}
                </Link>
              </li>
            ) : null}
            <li
              className={highlight === nav.manageUsers.key ? 'sidebar-item active' : 'sidebar-item'}
            >
              <Link className="nav-link" to={`${nav.manageUsers.path}/${installId}`}>
                <span className={`menu-icon ${nav.manageUsers.key}`} />
                {nav.manageUsers.title}
                {highlight === nav.manageUsers.key ? this.renderCurrent() : null}
              </Link>
            </li>
            <li
              className={highlight === nav.documents.key ? 'sidebar-item active' : 'sidebar-item'}
            >
              <a className="nav-link" href={nav.documents.path} rel="external">
                <span className={`menu-icon ${nav.documents.key}`} />
                {nav.documents.title}
                {highlight === nav.documents.key ? this.renderCurrent() : null}
              </a>
            </li>
          </div>
        ) : null}
      </ul>
    );
  };

  renderCurrent = () => renderSR('(current)');

  render() {
    return (
      <div className={this.setSidebarClass()}>
        <nav className="nav">
          <h3>Admin Menu</h3>
          {this.renderAdminLinks()}
        </nav>
      </div>
    );
  }
}
